export const ASSET_STATUS_FILTER_OPTIONS = [
  'FMC',
  'PMC',
  'NMC',
  'NMCM',
  'NMCS',
  'NMCD',
];
